

export const generateUuid: () => string = crypto.randomUUID.bind(crypto);
